var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flow-main", attrs: { id: "create-symbol-flow" } },
    [
      _c(
        "van-popup",
        {
          staticClass: "tip-popup",
          style: { height: "100%", width: "100%" },
          attrs: {
            closeable: !_vm.$route.query.isApp,
            overlay: false,
            "close-icon": _vm.isDirection ? "arrow" : "arrow-left",
            "close-icon-position": _vm.isDirection ? "top-right" : "top-left",
            position: "right"
          },
          on: { "click-close-icon": _vm.handleClose },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("h1", { staticClass: "tip-popup-title" }, [
            _vm._v(_vm._s(_vm.$t("8000118")) + "\n      "),
            _c("a", { staticClass: "FAQ-btn", on: { click: _vm.handleFAQ } }, [
              _vm._v("FAQ?")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip-popup-description" }, [
            _c("p", {
              staticClass: "content",
              domProps: { innerHTML: _vm._s(_vm.$t("8000121")) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "step-content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("8000127")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("8000131")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("8000133")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("8000136")))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "van-button",
            {
              attrs: {
                type: "primary",
                size: "large",
                loading: _vm.buttonLoading
              },
              on: { click: _vm.handleClick }
            },
            [_vm._v(_vm._s(_vm.$t("8000139")) + "\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flow-main-title" },
        [
          !_vm.$route.query.isApp
            ? _c("van-icon", {
                attrs: { name: _vm.isDirection ? "arrow" : "arrow-left" },
                on: { click: _vm.handleClose }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.$t("8000078")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("step-view", { attrs: { currentStep: _vm.currentStep } }),
      _vm._v(" "),
      _c("first-step", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep == 1,
            expression: "currentStep == 1"
          }
        ],
        ref: "firstStepDemo",
        on: { handleNextStep: _vm.nextStep }
      }),
      _vm._v(" "),
      _c("second-step", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep == 2,
            expression: "currentStep == 2"
          }
        ],
        ref: "secondStepDemo",
        attrs: { clearTemp: _vm.clearTemp },
        on: { handleNextStep: _vm.nextStep, handlePrev: _vm.prevStep }
      }),
      _vm._v(" "),
      _c("third-step", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep == 3,
            expression: "currentStep == 3"
          }
        ],
        ref: "thirdStepDemo",
        attrs: { createSubmitStatus: _vm.createSubmitStatus },
        on: { handleNextStep: _vm.nextStep, handlePrev: _vm.prevStep }
      }),
      _vm._v(" "),
      _c("fourth-step", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep == 4,
            expression: "currentStep == 4"
          }
        ],
        ref: "fourthStepDemo",
        on: { createFinish: _vm.handleCreateFinish }
      }),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "msg-tip-popup",
          attrs: {
            closeable: "",
            "close-icon": "cross",
            "close-icon-position": "top-right"
          },
          model: {
            value: _vm.tipsModel,
            callback: function($$v) {
              _vm.tipsModel = $$v
            },
            expression: "tipsModel"
          }
        },
        [
          _c(
            "div",
            { staticClass: "tip-message-box" },
            [
              _c(
                "svg",
                { staticClass: "icon", attrs: { "aria-hidden": "true" } },
                [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.errorLimitMsg))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleConfirm(_vm.buttonText)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.buttonText)))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58783da8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58783da8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/freeZone/createSymbolFlow.vue
// module id = 86Cl
// module chunks = 0